const sizing = {
    lineHeights: {
        half: '1.2rem',
        x1: '2.4rem',
        x2: '4.8rem',
        x3: '7.2rem',
        x4: '9.6rem'
    },
    widths: {
        icon: {
            // using numerical values makes icons compatible with React Native
            small: 16,
            regular: 36,
            large: 48,
            utility: 24
        },
        circle: {
            small: 24,
            regular: 48,
            large: 60
        },
        input: {
            small: '24rem',
            regular: '32rem',
            large: '100%'
        },
        full: '100%',
        layout: {
            page: {
                width: '100%',
                maxWidth: '130rem'
            },
            contained: {
                width: '100%',
                maxWidth: '64rem'
            },
            full: {
                width: '100%'
            }
        }
    },
    component: {
        padding: {
            none: 0,
            small: '0.8rem',
            regular: '2.4rem',
            large: '3.6rem'
        },
        margin: {
            none: 0,
            small: '0.6rem',
            regular: '2.4rem',
            large: '4.8rem'
        }
    },
    section: {
        padding: {
            none: 0,
            small: '2.4rem',
            regular: '3.6rem',
            large: '9.6rem'
        },
        margin: {
            none: 0,
            small: '1.2rem',
            regular: '2.4rem',
            large: '4.8rem'
        }
    },
    table: {
        padding: {
            small: '0.8rem',
            regular: '1.6rem',
            large: '2.4rem'
        }
    },
    container: {
        small: {
            maxWidth: '130rem',
            margin: '0 auto'
        },
        regular: {
            maxWidth: '154rem',
            margin: '0 auto'
        },
        large: {
            maxWidth: '100%'
        }
    }
};
export default sizing;
//# sourceMappingURL=sizing.js.map